import './Header.css';
import logo from '../../assets/iwcz-logo.jpg';
import { useNavigate } from 'react-router-dom';
import useAuthStatus from '../../hooks/useAuthStatus';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';

function Header() {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuthStatus();

  const logoutFn = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <header className="custom-header">
      <div className="header-left"></div>
      <div className="header-center">
        <img
          src={logo}
          alt="Logo"
          className="header-logo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="header-right">
        {user ? (
          <>
            <span className="welcome-message">Welcome, {profile?.name || user.email}!</span>
            <button className="delete-btn" onClick={logoutFn}>Logout</button>
          </>
        ) : (
          <button className="login-btn" onClick={() => navigate('/login')}>
            Login
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
